import { render, staticRenderFns } from "./personPicker.vue?vue&type=template&id=0d2a7658&scoped=true"
import script from "./personPicker.vue?vue&type=script&lang=js"
export * from "./personPicker.vue?vue&type=script&lang=js"
import style0 from "./personPicker.vue?vue&type=style&index=0&id=0d2a7658&prod&lang=less&scoped=true"
import style1 from "./personPicker.vue?vue&type=style&index=1&id=0d2a7658&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2a7658",
  null
  
)

export default component.exports